import { Component, OnInit } from '@angular/core';
import { LoadingAndErrors } from '../../../../classes';
import { Pagination } from '../../../../interfaces';
import { ProductsService } from '../../../../services';
import { LoopBackConfig, OrderApi, LoopBackAuth, PartnerApi, CardApi, AgentCommissionApi } from '../../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ORDER_STATUS, USER_ROLES, PAYMENT_METHOD } from '../../../../enums';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: [
    './order-details.component.css',
    '../order-form/order-form.component.css'
  ]
})
export class OrderDetailsComponent extends LoadingAndErrors implements OnInit {
  host: string = LoopBackConfig.getPath();
  ORDER_STATUS: typeof ORDER_STATUS = ORDER_STATUS;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  PAYMENT_METHOD: typeof PAYMENT_METHOD = PAYMENT_METHOD;
  pagination: Pagination = {
    page: 1,
    limit: 10,
    total: 0
  };
  state;
  merchantDetails;
  loadingMerchant;
  cards;
  commissions;
  loadingSapDetails;
  order: any = {};
  sapOrder = {};

  constructor(
    private route: ActivatedRoute,
    private partnerApi: PartnerApi,
    private productService: ProductsService,
    private modalService: BsModalService,
    private cardApi: CardApi,
    private orderApi: OrderApi,
    private loopBackAuth: LoopBackAuth,
    private commissionApi: AgentCommissionApi
  ) {
    super();
  }

  ngOnInit() {
    this.route.paramMap
      .subscribe(params => {
        this.state = {...params};
        this.loadSAPOrderDetails();
        this.loadOrderDetails();
        if (this.getUser() && !this.getUser().partnerId) {
          return this.getCommissions();
        }
      });
  }

  loadOrderDetails() {
    this.loading.order = true;
    this.clearErrors();
    this.orderApi
      .findById(this.state.params.id, {
        include: [
          'payments', {
            relation: 'orderItems',
            scope: this.getUser().partnerId ? {
              include: [{
                relation: 'commissions',
                scope: {
                  where: {
                    partnerId: this.getUser().partnerId,
                    orderId: this.state.params.id
                  }
                }
              }]
            } : undefined
          }
        ]
      })
      .pipe(finalize(() => {
        this.loading.order = false;
      }))
      .subscribe(order => {
        this.order = order;
        if ((this.getUser() && this.getUser().partnerId) !== (this.order && this.order.partnerId)) {
          this.loadMerchantDetails(this.order.partnerId);
        } else {
          this.getTokens();
        }
      }, error => {
        this.errors.order = error.message || 'Failed to load order details';
      });
  }

  loadSAPOrderDetails() {
    this.loadingSapDetails = true;
    this.clearErrors();
    this.orderApi
      .getSapOrderById(this.state.params.id)
      .pipe(finalize(() => {
        this.loadingSapDetails = false;
      }))
      .subscribe(sapOrder => {
        this.sapOrder = sapOrder
      }, error => {
        this.errors.sapOrder = error.message || 'Failed to load OR';
      });
  }

  loadMerchantDetails(userId) {
    this.loadingMerchant = true;
    this.clearErrors();
    this.partnerApi
      .findById(userId)
      .pipe(finalize(() => {
        this.loadingMerchant = false;
      }))
      .subscribe(details => {
        this.merchantDetails = details;
      }, error => {
        this.errors.merchantDetails = error.message || 'Unable to get Merchant Details';
      });
  }

  getTokens() {
    if (this.loading.list) {
      return;
    }
    this.loading.list = true;
    this.clearErrors();
    if (!this.cardApi) {
      this.loading.list = false;
      this.errors.list = 'Api property is not found in settings of class BasicList.'
      return;
    }
    this.cardApi
      .paginate({
        where: {
          orderId: this.state.params.id
        },
        offset: this.pagination.limit * (this.pagination.page - 1),
        limit: this.pagination.limit,
        include: [{
          relation: 'activations',
          scope: {
            where: { error: null }
          }
        }]
      })
      .pipe(finalize(() => {
        this.loading.list = false;
      }))
      .subscribe(
        (response: any) => {
          this.cards = response.data && response.data.data || [];
          this.pagination.total = response.data && response.data.total || 0;
        },
        error => {
          this.errors.list = error.message;
        }
      );
  }

  getCommissions() {
    if (this.loading.commissions) {
      return;
    }
    this.loading.commissions = true;
    this.clearErrors();
    if (!this.commissionApi) {
      this.loading.commissions = false;
      this.errors.commissions = 'Api property is not found in settings of class BasicList.'
      return;
    }
    this.commissionApi
      .find({
        where: {
          orderId: this.state.params.id
        },
        include: 'orderItem',
        order: 'partnerId DESC'
      })
      .pipe(finalize(() => {
        this.loading.commissions = false;
      }))
      .subscribe(
        (response: any) => {
          this.commissions = response && response || [];
        },
        error => {
          this.errors.commissions = error.message;
        }
      );
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
